import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';

import { Component, HostListener, type OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { FooterComponent } from '../../core/footer/footer.component';
import { HeaderComponent } from '../../core/header/header.component';

@Component({
  selector: 'app-layout',
  imports: [RouterOutlet, HeaderComponent, FooterComponent],
  standalone: true,
  templateUrl: './layout.component.html',
  styles: ``,
  providers: [],
  animations: [
    trigger('slideIn', [
      state('hidden', style({ transform: 'translateX(-100%)' })),
      state('visible', style({ transform: 'translateX(0)' })),
      transition('hidden => visible', animate('500ms ease-in-out')),
    ]),
  ],
})
export class LayoutComponent implements OnInit {
  layoutType: any;
  isVisible = false;

  @HostListener('window:resize')
  onResize() {}

  onToggleMobileMenu() {}

  showBackdrop() {}

  ngOnInit() {}
}
